<mat-checkbox [checked]="enabled" [disabled]="loading || saving" (change)="onEnabledChange($event.checked)">
    Paciente acepta visualización portal derivantes
</mat-checkbox>
